import FacultyCard from "Benchmarking/Components/FacultyCard";
import { PaginationAdjustComponentBenchmarking } from "Benchmarking/Components/PaginationComponent";
import SearchAdvanceFaculty from "Benchmarking/Components/SearchAdvanceFaculty";
import "Benchmarking/Scss/FacultyProfiles.scss";
import {
  getFacultyExplore,
  getSearchAuthors,
} from "Benchmarking/Services/Author";
import { List, Spin } from "antd";
import { useEffect, useState } from "react";

const FacultyProfiles = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 16,
    totalRows: 0,
  });
  const [totalData, setTotalData] = useState([]);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    query: null,
    seniorities: null,
    positions: null,
    institutions: null,
    departments: null,
    classifications: null,
    states: null,
  });
  useEffect(() => {
    if (totalData.length == 0) {
      getFacultyExplore((res) => {
        setTotalData(res);
        setPagination({
          ...pagination,
          totalRows: res.length,
        });
        setData(
          res.slice(
            (pagination.page - 1) * pagination.rowsPerPage,
            pagination.page * pagination.rowsPerPage
          )
        );
        setIsLoading(false);
      });
    } else {
      setData(
        totalData.slice(
          (pagination.page - 1) * pagination.rowsPerPage,
          pagination.page * pagination.rowsPerPage
        )
      );
    }
  }, [pagination.page, pagination.rowsPerPage]);

  useEffect(() => {
    if (
      filters.query !== null ||
      filters.seniorities !== null ||
      filters.positions !== null ||
      filters.institutions !== null ||
      filters.departments !== null ||
      filters.classifications !== null ||
      filters.states !== null
    ) {
      setIsLoading(true);
      getSearchAuthors(filters, (res) => {
        setData(res);
        setPagination({
          ...pagination,
          totalRows: res.length,
        });
        setIsLoading(false);
      });
    }
  }, [filters]);
  return (
    <div className="faculty-profiles-list scroll-section">
      <div className="left-side">
        <div className="search">
          <SearchAdvanceFaculty filters={filters} setFilters={setFilters} />
        </div>

        {isLoading ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <div className="list">
            <List
              grid={{
                gutter: 25,
                column: 4,
              }}
              dataSource={data}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <FacultyCard data={item} compareList={data} />
                  </List.Item>
                );
              }}
            />
            <PaginationAdjustComponentBenchmarking
              pagination={pagination}
              setPagination={setPagination}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FacultyProfiles;
